module.exports = __webpack_public_path__ + "img/img_home_panel_1.7d2def7e.jpg";